module.exports = __webpack_public_path__ + "665722b72ae98b0d825fea3f8f6a5147.fbx";